import React from "react";
import { BsFillArrowUpCircleFill } from "react-icons/bs";

export default function CommentInput({ setDownloadAppModalOpen }) {
  return (
    <div className="bg-white w-full h-auto min-h-[75px] py-1.5 flex flex-row flex px-2">
      <div
        aria-hidden
        className="flex items-center justify-center px-2 w-full flex-row "
      >
        <div
          aria-hidden
          className="cursor-pointer h-[35px] max-h-[120px] outline-none w-full rounded-2xl"
          onClick={() => setDownloadAppModalOpen(true)}
        >
          <input
            disabled
            placeholder="Add a comment"
            className="cursor-pointer text-gray-500 bg-gray-100 h-full max-h-full outline-none w-full py-1.5 px-2  rounded-2xl border border-gray-400 hover:border-gray-400 overflow-y-hidden"
          />
        </div>

        <SubmitCommentButton className="px-2" />
      </div>
    </div>
  );
}

// Submit button for submitting a new comment to a post.
function SubmitCommentButton() {
  return (
    <div className="mx-2">
      <BsFillArrowUpCircleFill className="text-gray-400 h-9 w-9" />
    </div>
  );
}
